import styled from '@emotion/styled';

export const Button = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${(props) => props.theme.colors.primary400};
	padding: 1rem;
	border: none;
	bottom: 3rem;
	right: 3rem;
	cursor: pointer;
`;

export const ButtonBox = styled.div`
	position: fixed;
	right: 3rem;
	bottom: 3rem;
	z-index: 1;
	@media (max-width: 1180px) {
		right: 2rem;
		bottom: 1.8rem;
	}
`;
